import { ModelBase, NormalString, Property, VeryLongString, VeryShortString } from '@skylab-shared/core';

export class AddressModel extends ModelBase {
    @Property()
    @NormalString('data-model.address.validation.city.length')
    public city: string;

    @Property()
    public countryId: number;

    @Property()
    @VeryLongString('data-model.address.validation.line1.length')
    public line1: string;

    @Property(String, {nullable: true})
    public line2: string | null;

    @Property()
    @VeryLongString('data-model.address.validation.name.length')
    public name: string;

    @Property()
    @VeryShortString('data-model.address.validation.zip-code.length')
    public zipCode: string;

    public isFilled(): boolean {
        return !!(this.name || this.city || this.line1 || this.zipCode);
    }
}
